<template>
  <div v-if="isLoaded">
    <transition>
      <div class="row" v-if="unitsErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ unitsErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
      <div class="col text-right" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
      <div class="col-auto text-right">
        <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
      </div>
    </div>

    <form @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              v-model="formData.termin"
              :disabled="isBilled || isCoachBilled"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12  ">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :key="startTimeKey"
                  v-model="formData.startTime"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  :minutesArray="minutesArray"
                  label="Startzeit"/>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :key="endTimeKey"
                  v-model="formData.endTime"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  :minutesArray="minutesArray"
                  label="Endzeit"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.presence"
                     :options="presenceDropdown"
                     :disabled="isBilled || isCoachBilled"
                     :required="true"
                     label="Anwesenheit"
                     placeholder="Wählen Sie Anwesenheit"
                     :validation="v$.presence"
                     :messages="v$.presence.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseCheckbox
              v-model="formData.overwrite"
              :disabled="isBilled || isCoachBilled"
              label="Überschreiben"/>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-4 col-sm-6 col-12 ">
          <BaseNumber
              v-model="formData.units"
              label="Einheiten"
              disabled="disabled"
              :validation="v$.units"
              :messages="v$.units.required.$message"/>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-4 col-sm-6 col-12 ">
          <BaseNumber
              v-model="formData.totalMinutes"
              label="in Minuten"
              disabled="disabled"
              :validation="v$.totalMinutes"
              :messages="v$.totalMinutes.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.coachType"
                     :options="portalCoachTypeDropdown"
                     :disabled="isBilled || isCoachBilled"
                     :required="true"
                     :is-clear="true"
                     label="Coachart"
                     placeholder="Wählen Sie Coachart"
                     :validation="v$.coachType"
                     :messages="v$.coachType.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                v-model="formData.signature"
                :disabled="isBilled || isCoachBilled || isDigitalSignature"
                label="Unterschrift"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class="mt-4">
            <BaseCheckbox
                v-model="formData.billed"
                :disabled="isBilled"
                label="Abgerechnet"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class=" mt-4">
            <BaseCheckbox
                v-model="formData.paid"
                :disabled="isCoachBilled"
                label="Bezahlt"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                v-model="formData.homeVisit"
                :disabled="isBilled || isCoachBilled"
                label="Hausbesuch"
                :labelPosition="'right'"
            />
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <SelectVue v-model="formData.contactType"
                     :options="contactTypeFiltered"
                     :disabled="isBilled || isCoachBilled"
                     :is-clear="true"
                     label="Kontaktart"
                     placeholder="Wert auswählen"
                     :validation="v$.contactType"
                     :messages="v$.contactType.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <SelectVue v-model="formData.conversationType"
                     :disabled="isBilled || isCoachBilled"
                     :options="conversationTypeDropdown"
                     :is-clear="true"
                     label="Gesprächsart"
                     placeholder="Wert auswählen"
                     :validation="v$.conversationType"
                     :messages="v$.conversationType.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12"
             v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ">
          <SelectVue v-model="formData.coachId"
                     :disabled="isCoachBilled"
                     :options="coachDropdown"
                     :is-clear="true"
                     label="Coach"
                     placeholder="Trainer auswählen"/>
        </div>
      </div>

      <div class="row mt-3 pt-3" style="border-top: 1px solid #ddd">
        <div class="col-12">
          <h6>Einschränkung</h6>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <BaseInput v-model="formData.meetingTopic"
                     label="Sitzungsthema"
                     :required="true"
                     :validation="v$.meetingTopic"
                     :messages="v$.meetingTopic.required.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <TextEditor
              v-model="formData.description"
              @update:model-value="formData.description = $event"
              :inputStyle="{ height: '200px' }"
              label="Beschreibung"/>
        </div>
      </div>

      <div v-if="!unitsErrorMessage" class="d-flex justify-content-center w-100 mt-4">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalCaseManagementCoachingService from '@/api/Portal/CaseManagementCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {addDeletedCoachToDropdown} from '@/shared/portal/commonFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import BaseToggle from "@/components/base/BaseToggle.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const coachDropdown = ref([]);
const presenceDropdown = ref([]);
const portalCoachTypeDropdown = ref([]);
const contactTypeDropdown = ref([]);
const conversationTypeDropdown = ref([]);
const unitsErrorMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);
const updateAsAdmin = ref(false)
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic

const contactTypeFiltered = computed(() => {
  return piniaEnumsState.enums.contactTypes.filter(type => type.value !== 'personal'
  );
});

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  protocolId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  isDigitalSignature: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coachingId = toRefs(props)['coachingId'];
const protocolId = toRefs(props)['protocolId'];

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  coachType: '',
  overwrite: false,
  units: 0,
  totalMinutes: 0,
  conversationType: '',
  contactType: '',
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  meetingTopic: '',
  description: '',
});

const originalFormData = ref({});
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  units: requiredRule(t),
  totalMinutes: requiredRule(t),
  meetingTopic: requiredRule(t),
  contactType: requiredRule(t),
  conversationType: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer
    formData.value.totalMinutes = Number(formData.value.totalMinutes);// or parseFloat if you prefer

    if (props.protocolId) {
      if (updateAsAdmin.value) {
        await portalCaseManagementCoachingService.updateProtocolAsAdmin(
            formData.value,
            +protocolId.value
        );
      } else {
        await portalCaseManagementCoachingService.updateProtocol(
            formData.value,
            +protocolId.value
        );
      }
    } else {
      await portalCaseManagementCoachingService.postProtocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const {data} = await portalCaseManagementCoachingService.getProtocol(protocolId.value);
    const coachId = data.data?.coach?.id;

    isBilled.value = data.data.invoiced;
    isCoachBilled.value = data.data.coachInvoiced;

    // Save original values
    originalIsBilled.value = data.data.invoiced;
    originalIsCoachBilled.value = data.data.coachInvoiced;

    addDeletedCoachToDropdown(data.data?.coach, coachDropdown);

    const selectedContactType = data.data.contactType
    if (selectedContactType === 'personal') {
      contactTypeFiltered.value.push({label: 'Persönlich', value: 'personal'});
    }

    formData.value = {
      ...data.data,
      coachId: coachId,
    };

    // store original as a deep copy !!!
    originalFormData.value = JSON.parse(JSON.stringify(formData.value));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getAssignedCoaches(coachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getCaseManagementCoachingAssignedCoaches(+coachingId);
    coachDropdown.value = data.data.map(item => ({
      label: `${item.firstName}` + ' ' + `${item.lastName}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;
    const unitDuration = 60;
    let units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);

    onChangeUnits(units);

    // Check a presence type
    if ((formData.value.presence)) {
      if (formData.value.presence === 'anwesend') {
        units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
      } else {
        units = 1;
      }
    }

    // If presenceType is selected and overview is true, calculate units
    if (formData.value.overwrite === true) {
      units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
    }

    formData.value.units = Number(units).toFixed(2);
    formData.value.totalMinutes = diffMinutes;
  } else {
    formData.value.units = 0;
    formData.value.totalMinutes = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Einheiten müssen runde Zahlen sein, die größer als 0 sind.';
  } else {
    unitsErrorMessage.value = '';
  }
}

watch(
    () => [
      formData.value.startTime,
      formData.value.endTime,
      formData.value.presence,
      formData.value.overwrite,
    ],
    calculateTimeDifference,
);

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
  }
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    (originalIsBilled.value || originalIsCoachBilled.value)
);

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
  portalCoachTypeDropdown.value = getEnums?.value?.portalCoachTypes || [];
  conversationTypeDropdown.value = getEnums?.value?.conversationTypes || [];
}

const minutesArray = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35',
  '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47',
  '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
];

onMounted(async () => {
  await Promise.all([
    getAssignedCoaches(+coachingId.value),
    getEnumsDropdown(),
  ]);

  if (protocolId.value) {
    await getProtocolData(protocolId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>